import type { Notices } from "@/lib/notices"

export const buildNotice: Notices.Functions.BuildNotice = ({
  id,
  message,
  persistence,
  type,
}) => {
  return {
    id,
    message,
    persistence: {
      accruedRouteChanges: 0,
      maxRouteChanges: 1,
      untilDismissed: false,
      ...persistence,
    },
    type,
  }
}
